<template>
  <div id="wrapper">
    <Nav :message="message" />
    <TrainingList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import TrainingList from '@/components/training/TrainingList.vue'

export default {
  name: 'training',
  props: ['message'],
  components: {
    Nav,
    TrainingList
  }
}
</script>